import { BASE_URL } from '../../constants';
import { CustomerPurchaseFlowTicketsPage } from '../../models/ticketsPage';
import { CheckoutState } from '../../state';
import { getInitialPath } from '../../utils/routes';

export const getIsCustomerPurchaseFlow = (state: CheckoutState): boolean =>
    Object.values(CustomerPurchaseFlowTicketsPage).includes(
        getInitialPath(state).replace(
            BASE_URL,
            '',
        ) as CustomerPurchaseFlowTicketsPage,
    );
